import React from 'react';
import { getIn18Text } from 'api';
import moment from 'moment';
import './index.scss';
export const FormatExpiredDate = ({ date }) => {
    const time = Number(date);
    if (!time) {
        return React.createElement(React.Fragment, null, getIn18Text('YONGBUGUOQI'));
    }
    if (time == null || time === 0) {
        return React.createElement(React.Fragment, null, getIn18Text('YONGBUGUOQI'));
    }
    const targetDate = moment(time);
    const digitOne2double = (data) => {
        if (String(data).length < 2) {
            return `0${data}`;
        }
        return `${data}`;
    };
    if (targetDate.isValid()) {
        const currentDate = moment();
        if (targetDate.diff(currentDate) < 0) {
            return React.createElement("span", { className: "expired" }, getIn18Text('YIGUOQI'));
        }
        const totalMinute = targetDate.diff(currentDate) / (1000 * 60);
        const restDays = Math.floor(totalMinute / (60 * 24));
        const restHours = Math.floor((totalMinute - restDays * 60 * 24) / 60);
        const restMinute = Math.floor((totalMinute - restDays * 60 * 24) % 60);
        if (restDays >= 1) {
            return React.createElement("span", { className: "over-1-day" }, `${digitOne2double(restDays)}天${digitOne2double(restHours)}小时`);
        }
        else if (restHours >= 1) {
            return React.createElement("span", { className: "in-1-day" }, `${digitOne2double(restHours)}小时${digitOne2double(restMinute)}分钟`);
        }
        else {
            return React.createElement("span", { className: "in-1-day" }, `${digitOne2double(restMinute)}分钟`);
        }
    }
    return React.createElement(React.Fragment, null);
};
